import { useNavigate, useLocation } from "react-router-dom";
import { Home, Plus, Snowflake, Menu } from "lucide-react";
import { SERVERS, DM_CONVERSATIONS, GROUP_CHATS, getInitials, getAvatarColor } from "@/mock/data";
import { useModalStore } from "@/store/modalStore";
import { useUIStore } from "@/store/uiStore";
import "./SnowRail.css";

export function SnowRail() {
  const navigate = useNavigate();
  const location = useLocation();
  const isHome = location.pathname.startsWith("/app/dm") || location.pathname.startsWith("/app/group");
  const activeServerId = location.pathname.startsWith("/app/server/")
    ? location.pathname.split("/")[3]
    : null;
  const openModal = useModalStore((s) => s.openModal);
  const toggleSidebar = useUIStore((s) => s.toggleSidebar);

  const dmHasUnread = DM_CONVERSATIONS.some((c) => c.unreadCount > 0);
  const groupHasUnread = GROUP_CHATS.some((g) => g.unreadCount > 0);
  const homeHasUnread = dmHasUnread || groupHasUnread;

  function getServerUnread(serverId: string): boolean {
    return false;
  }

  return (
    <nav className="snow-rail" aria-label="Navigation">
      <button className="snow-rail__hamburger" onClick={toggleSidebar} aria-label="Menu">
        <Menu size={18} />
      </button>

      <div className="snow-rail__brand" onClick={() => navigate("/app/dm")}>
        <Snowflake size={18} className="snow-rail__brand-icon" />
        <span className="snow-rail__brand-name">snowcord</span>
      </div>

      <div className="snow-rail__divider-v" />

      <div className="snow-rail__items">
        <button
          className={`snow-rail__item${isHome ? " snow-rail__item--active" : ""}`}
          onClick={() => navigate("/app/dm")}
          aria-label="Home"
        >
          <Home size={16} />
          <span className="snow-rail__item-label">home</span>
          {homeHasUnread && !isHome && <div className="snow-rail__unread" />}
        </button>

        <div className="snow-rail__divider-h" />

        {SERVERS.map((server) => {
          const isActive = activeServerId === server.id;
          const hasUnread = getServerUnread(server.id);
          return (
            <button
              className={`snow-rail__item${isActive ? " snow-rail__item--active" : ""}`}
              key={server.id}
              onClick={() => navigate(`/app/server/${server.id}/channel/${server.id === "s1" ? "ch2" : "ch5"}`)}
              aria-label={server.name}
              title={server.name}
            >
              <div
                className="snow-rail__server-dot"
                style={{ background: isActive ? "var(--accent)" : getAvatarColor(server.id) }}
              >
                {getInitials(server.name)}
              </div>
              <span className="snow-rail__item-label">{server.name}</span>
              {hasUnread && !isActive && <div className="snow-rail__unread" />}
            </button>
          );
        })}

        <div className="snow-rail__divider-h" />

        <button
          className="snow-rail__item snow-rail__item--add"
          aria-label="Add server"
          title="Add Server"
          onClick={() => openModal("create-server")}
        >
          <Plus size={16} />
          <span className="snow-rail__item-label">new</span>
        </button>
      </div>
    </nav>
  );
}
